import { render, staticRenderFns } from "./BedbuilderProductImage.vue?vue&type=template&id=c1dfce98&"
import script from "./BedbuilderProductImage.vue?vue&type=script&lang=js&"
export * from "./BedbuilderProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports